import { itiHttpService } from './../../iti-core-vue/services/iti-http-service';
//import Header from '@/components/header/header.component.vue';
//import Header from '@/components/public-header/public-header.component.vue';
import Header from '@/components/private-header/private-header.component.vue';
import PrivateMenuRootComponent from '@/components/private-menu-root/private-menu-root.component.vue';
import ItiMenuRoot from '@/iti-core-vuetify/components/menu/iti-menu-root.vue';
import { itiPermissionService, ItiString, itiTokenService } from '@/iti-core-vue';
import { Permission } from '@/shared';
import { MenuOptions } from '@/shared/menu-options';
import itiLayoutMenuModule from '@/store/modules/iti-layout-menu.module';
import { Component, Vue } from "vue-property-decorator";
import AuthService from '@/shared/services/auth.service';
import permissionsModule from '@/store/modules/permissions.module';
import { ItiMenuItem } from '@/iti-core-vuetify';
import NotificacionInferior from '@/components/notificacion-inferior/notificacion-inferior.vue';
const auth = new AuthService();

@Component({
  components: {
    ItiMenuRoot,
    Header,
    PrivateMenuRootComponent,
    NotificacionInferior  
  }
})
export default class PrivateAreaLayout extends Vue {

  public appTitle = process.env.VUE_APP_TITLE;

  public fullMenuOptions = MenuOptions;

  public currentUser: string | undefined = '';
  public accessTokenExpired: boolean | undefined = false;
  public isLoggedIn: boolean = false;

  public get drawer(): boolean {
    return itiLayoutMenuModule.visible;
  }

  public set drawer(newtoggle: boolean) {
    itiLayoutMenuModule.setVisible(newtoggle);
  }

  async created() {
    await permissionsModule.getPermissions();
  }
  public mounted() {
    auth.getUser().then((user) => {
      //console.log(user);
      if (user) {
        itiTokenService.setToken(user.access_token);
        itiHttpService.updateHeader();
        this.currentUser = user.profile?.name;
        this.accessTokenExpired = user.expired;
        this.isLoggedIn = (user !== null && !user.expired);
      }
    });
  }
}
